import type { CallBase, ChatBase } from 'rcx_adapter';
import { ChannelType } from 'rcx_adapter/src/rules/constants';
import type { ChannelRuleConfigs } from 'rcx_adapter/src/rules/types';

export const ruleConfigsForDigital: ChannelRuleConfigs = {
    [ChannelType.DIGITAL_EMAIL]: {
        getMatchingRules: (data: ChatBase) => {
            const value = data.edUuid || '';
            return {
                matchingRules: [
                    {
                        crmEntityType: ['Account', 'Contact', 'Consumer'],
                        crmEntityIdName: 'email',
                        crmEntityValue: value,
                    },
                    { crmEntityType: ['Case', 'CaseTask'], crmEntityIdName: 'u_email', crmEntityValue: value },
                ],
            };
        },
    },
    [ChannelType.DIGITAL_SMS]: {
        getMatchingRules: (data: ChatBase) => {
            const value = data.ani || data.edUuid || '';
            return {
                matchingRules: [
                    { crmEntityType: ['Account', 'Contact'], crmEntityIdName: 'phone', crmEntityValue: value },
                    { crmEntityType: ['Consumer'], crmEntityIdName: 'business_phone', crmEntityValue: value },
                    { crmEntityType: ['Case', 'CaseTask'], crmEntityIdName: 'u_phone', crmEntityValue: value },
                ],
            };
        },
    },
    [ChannelType.DIGITAL_MSG]: {
        getMatchingRules: (data: ChatBase) => ({
            matchingRules: [
                { crmEntityType: ['*'], crmEntityIdName: 'u_rcx_digital_uuid', crmEntityValue: data.edUuid || '' },
            ],
        }),
    },
};

export const ruleConfigsForIncidentVoice: ChannelRuleConfigs = {
    [ChannelType.VOICE]: {
        getMatchingRules: (data: CallBase & { callLoggingType?: string }) => {
            const value = data?.ani || data?.aniE164 || '';
            return {
                matchingRules: [{ crmEntityType: ['User'], crmEntityIdName: 'phone', crmEntityValue: value }],
            };
        },
    },
};

export const ruleConfigsForInteractionVoice: ChannelRuleConfigs = {
    [ChannelType.VOICE]: {
        getMatchingRules: (data: CallBase & { callLoggingType?: string }) => {
            const value = data?.ani || data?.aniE164 || '';
            return {
                matchingRules: [
                    { crmEntityType: ['Account', 'Contact'], crmEntityIdName: 'phone', crmEntityValue: value },
                    { crmEntityType: ['Consumer'], crmEntityIdName: 'business_phone', crmEntityValue: value },
                    { crmEntityType: ['Case', 'CaseTask'], crmEntityIdName: 'u_phone', crmEntityValue: value },
                ],
            };
        },
    },
};
